
    import { computed, defineComponent, onBeforeMount, watch } from 'vue'
    import { useI18n } from 'vue-i18n-composable'
    import { useRoute } from 'vue-router/composables'

    import Post from '@/app/components/common/posts/Post.vue'
    import { useBreadcrumbsStore } from '@/app/stores/breadcrumbs'
    import { useNewsStore } from '@/app/stores/news'

    import { useHeadful } from '@/common/composables/libs/headful'
    import NotFoundError from '@/common/errors/not-found-error'

    export default defineComponent({
        components: {
            Post
        },
        props: {
            slug: {
                type: String,
                default: ''
            }
        },
        setup (props) {
            const newsStore = useNewsStore()
            const headful = useHeadful()
            const i18n = useI18n()
            const route = useRoute()

            const data = computed(() => newsStore.bySlug(props.slug))
            const post = computed(() => data.value.post)
            const shares = computed(() => data.value.shares)
            const similar = computed(() => data.value.similar)

            const loadPage = async (): Promise<void> => {
                if (props.slug === '') {
                    throw new NotFoundError()
                }

                // Loading the entry first, so we have access to it later
                await newsStore.loadBySlug({
                    slug: props.slug,
                    params: !route.query.expires || !route.query.signature ? undefined : {
                        expires: route.query.expires as string,
                        signature: route.query.signature as string
                    }
                })

                useBreadcrumbsStore().set([
                    { text: i18n.t('nav.news').toString(), to: { name: 'news' } },
                    { text: post.value.title }
                ])

                headful({
                    title: `${post.value.title} | ${i18n.t('meta.title').toString()}`
                })
            }

            watch(() => props.slug, async (): Promise<void> => {
                await loadPage()
            })

            onBeforeMount(async (): Promise<void> => {
                await loadPage()
            })

            return {
                post,
                shares,
                similar
            }
        }
    })
